import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { OptionsStateModule } from '@nibtravel/shared/data-access/options';
import { PlansStateModule } from '@nibtravel/shared/data-access/plans';
import { QuoteStateModule } from '@nibtravel/shared/data-access/quote';
import { OptionModule } from '@nibtravel/shared/ui/components/option';
import { CheckboxModule } from '@nibtravel/shared/ui/forms/checkbox';

import { PmiOptionComponent } from './pmi-option.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    OptionModule,
    CheckboxModule,
    QuoteStateModule,
    PlansStateModule,
    OptionsStateModule,
  ],
  declarations: [PmiOptionComponent],
  exports: [PmiOptionComponent],
})
export class PmiOptionModule {}
